import React from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
// component;
import BranchPaymentRegister from "./branch_payment_register";
import BranchPaymentEdit from "./branch_payment_edit";
import BranchExternalAccount from "./branch_external_account";
// redux
import { detailSelector } from "../../store/branch/branch.selector";

const BranchPayment = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(detailSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    if (detail?.stripeAccount) {
      return <BranchPaymentEdit />;
    }
    return <BranchPaymentRegister />;
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col lg={16} md={16} sm={16} xs={24}>
        {renderBody()}
      </Col>
      <Col lg={8} md={8} sm={8} xs={24}>
        <BranchExternalAccount />
      </Col>
    </Row>
  );
};

export default BranchPayment;
